import { render, staticRenderFns } from "./agv-article-size.vue?vue&type=template&id=6c8ea5d3&scoped=true&lang=pug&"
import script from "./agv-article-size.vue?vue&type=script&lang=js&"
export * from "./agv-article-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ea5d3",
  null
  
)

export default component.exports